import React, { useState, useEffect, useRef } from "react";
import $ from 'jquery';
import LZString from 'lz-string';
import SessionManager from '../../routes/SessionManager';
import moment from 'moment';
import DateUtil from "../../util/DateUtil";
import Loading from '../Loading';
import { Bar } from "react-chartjs-2";
import { Select, Comment, List, Input, Modal, DatePicker } from 'antd';
import Toastr from 'toastr';
import AdvanceWorkHours from "../settings/AdvanceWorkHours";
import DownloadReport from "../common/DownloadReport";
import ImageResize from "../common/ImageResize";
import ZoneHistoryCarousel from "../zone-history/ZoneHistoryCarousel";

let sortedZones = null;
let time = [];
function AfterHoursVisitorsReport(props) {
    var sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let submitting = {};
    var site_config = {};
    let isMount = useRef(true);
    site_config = { ...DateUtil.getConfiguredWorkHours(user.site_selected) };
    let startTime = new Date();
    startTime.setHours(parseInt(site_config.work_hours.work_hours_start.replace(":00", "")));
    startTime.setMinutes(0);
    let endTime = new Date();
    if (site_config.work_hours.work_hours_end === '23:59')
        site_config.work_hours.work_hours_end = '00:00';
    endTime.setHours(parseInt(site_config.work_hours.work_hours_end.replace(":00", "")));
    endTime.setMinutes(0);

    let location_map = {};
    let location_ids = user.zones && user.zones.length > 0 && user.zones.map(z => {
        location_map[z.location_id] = z.location_name;
        return z.location_id
    }).reduce((prev, curr) => `${prev},${curr}`);
    let zones = user.zones;

    const [loading, setLoading] = useState(true);
    const [sdr_url, setSdr_url] = useState("");
    const [date, setDate] = useState(props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"));
    const [zonesAfterWorkHrsData, setZonesAfterWorkHrsData] = useState([]);
    const [currentComment, setCurrentComment] = useState({});
    const [vehicle_info, setVehicle_info] = useState(null);
    const [redirectHistory, setRedirectHistory] = useState(false);
    const [bbox_info, setBbox_info] = useState(null);
    const [showAdvancedWorkHours, setShowAdvancedWorkHours] = useState(false);
    const [location_name, setLocation_name] = useState();
    const [isNightOverlap, setIsNightOverlap] = useState(null);
    const [selected_dataset, setSelected_dataset] = useState([]);
    const [all_dataset, setAll_dataset] = useState(null);

    let start_Time = moment(endTime).format("LT");
    let end_Time = moment(startTime).format("LT");
    let extended_enable = user.site_selected.site_config.work_hours.extended_enabled;

    useEffect(() => {
        fetchHumanPower();
        return () => isMount.current = false;
    }, [date]);

    useEffect(() => {
        if (bbox_info !== null) {
            fetchvehiclelInfo();
        }
    }, [bbox_info]);

    useEffect(() => {
        if (vehicle_info !== null) {
            chartData();
        }
    }, [vehicle_info]);

    // const handleClick = () => {
    //     ReactGA.event({
    //         category: 'Navigation',
    //         action: 'Clicked Download Report',
    //         label: 'Download After Hours Visitor Report'
    //     });
    // }

    const onDateChange = (date) => {
        setDate(moment(new Date(date)).format('YYYY-MM-DD'));
        setLoading(true);
    };

    const fetchvehiclelInfo = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            date: date,
            location_id: location_ids,
            timezone: user.site_selected.site_iana_timezone,
            after_hrs_report: true,
            tracking_type: 'vehicle'
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/human-power',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var zonesAfterWorkHrs = [];
                    var data = res.data;

                    time = [];
                    for (const element of data) {
                        var location_name = zones.find(z => z.location_id === element.location_id).location_name;
                        element.location_name = location_name

                        //Filter the data based on off-working hours
                        var getDay = moment.tz(element.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('dddd');
                        var include_weekends = user.site_selected.site_config.work_hours.include_weekends;

                        if (getDay === "Saturday" && include_weekends !== "6" && include_weekends !== "6 7") {
                            zonesAfterWorkHrs.push(element);
                        } else if (getDay === "Sunday" && include_weekends !== "7" && include_weekends !== "6 7") {
                            zonesAfterWorkHrs.push(element);
                        } else {
                            zonesAfterWorkHrs.push(element);
                        }
                    }
                    if (isMount.current)
                        setVehicle_info(zonesAfterWorkHrs);
                } else {
                    setLoading(false);
                }
            });
    }

    const fetchHumanPower = () => {
        isMount.current = true;
        var data = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            date: date,
            location_id: location_ids,
            timezone: user.site_selected.site_iana_timezone,
            after_hrs_report: true
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/human-power',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var zonesAfterWorkHrsData = [];
                    var data = res.data;

                    let hh_range = [moment(start_Time, 'hh:mm a').format('HH'), moment(end_Time, 'hh:mm a').format('HH')];
                    let isNightOverlap = parseInt(hh_range[0]) > parseInt(hh_range[1]);

                    for (const element of data) {
                        var location_name = zones.find(z => z.location_id === element.location_id).location_name;
                        var zone = zones.find(z => z.location_id === element.location_id);
                        var people_detection = zone.location_config && zone.location_config.feature_controls && zone.location_config.feature_controls.motion_detection && zone.location_config.feature_controls.motion_detection.enabled;
                        if (people_detection === false) {
                            continue;
                        }
                        //Image comments
                        element['location_name'] = location_name;
                        if (element.comments.trim() !== "") {
                            element.comments = JSON.parse(element.comments);
                        } else {
                            element.comments = element.comments.trim();
                        }

                        //Filter the data based on off-working hours
                        var getDay = moment.tz(element.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('dddd');
                        var include_weekends = user.site_selected.site_config.work_hours.include_weekends;

                        if (getDay === "Saturday" && include_weekends !== "6" && include_weekends !== "6 7") {
                            zonesAfterWorkHrsData.push(element);
                        } else if (getDay === "Sunday" && include_weekends !== "7" && include_weekends !== "6 7") {
                            zonesAfterWorkHrsData.push(element);
                        } else {
                            zonesAfterWorkHrsData.push(element);
                        }
                    }

                    let human_power = res.data.map((element) => element.dev_timestamp);
                    let human_power_data = { isNightOverlap: isNightOverlap, zonesAfterWorkHrsData, loading: false, human_power: human_power };

                    if (user.site_selected) {
                        var minifiedUser = preparePDFData({ ...user });
                        minifiedUser.date = date;
                        minifiedUser.startTime = start_Time;
                        minifiedUser.endTime = end_Time;
                        minifiedUser.extended_enable = extended_enable;
                        minifiedUser.is_today = minifiedUser.date && minifiedUser.date === moment().format("YYYY-MM-DD");

                        let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + '_' + date;

                        minifiedUser.save_report = true;
                        minifiedUser.request_id = "After Hours Visitors Report - " + site_info + ".pdf";
                        if (isMount.current)
                            setSdr_url('https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/pdf/after-hours-visitors-report/After Hours Visitors Report - ' + site_info + '.pdf?' + LZString.compressToBase64(JSON.stringify(minifiedUser)) + '=payload&host=' + window.location.host);
                    }
                    time = [];
                    if (isMount.current)
                        fetchBoundingBoxesInfo(human_power_data);
                } else {
                    setLoading(false);
                }
            });
    }

    const fetchBoundingBoxesInfo = (human_power_data) => {
        var timestamps = human_power_data.human_power;
        var data = {
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            location_id: location_ids,
            sec_timestamps: timestamps.join(',')
        };
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/bounding-boxes-info',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var bbox_data = res.data;
                    var bbox_info = {};
                    for (let rec of bbox_data) {
                        let k = rec.location_id + "_" + rec.sec_timestamp;
                        if (!bbox_info[k]) {
                            bbox_info[k] = [];
                        }
                        bbox_info[k].push(rec);
                    }
                    if (isMount.current) {
                        setBbox_info(bbox_info);
                        setIsNightOverlap(human_power_data.isNightOverlap);
                        setZonesAfterWorkHrsData(human_power_data.zonesAfterWorkHrsData);
                    }
                }
            },
            (res) => {
                setBbox_info({});
                setIsNightOverlap(human_power_data.isNightOverlap);
                setZonesAfterWorkHrsData(human_power_data.zonesAfterWorkHrsData);
                setLoading(human_power_data.loading);

            });
    };

    const applyBoundingBoxes = (id, location_id) => {
        let currentImage = $('#' + id);
        var currentImageUrl = currentImage.attr('original_src');
        var imageTimeStamp = 0;
        if (currentImageUrl && currentImageUrl.indexOf("?") > 0) {
            try {
                currentImageUrl = currentImageUrl.split("?")[0];
                imageTimeStamp = currentImageUrl.split('_');
                imageTimeStamp = imageTimeStamp[imageTimeStamp.length - 1].replace('.jpg', '').replace('.jpeg', '');

                if (user.customer_id === '10378730415758') {
                    imageTimeStamp = currentImage.attr('sec_timestamp');
                }

                var bb_data = bbox_info[location_id + "_" + imageTimeStamp];
                if (bb_data && bb_data.length > 0) {
                    for (var bb of bb_data) {
                        var w = $(currentImage).parent().width();
                        var h = $(currentImage).parent().height();

                        if (bb['bbox_h'] === bb['bbox_w'] && bb['bbox_h'] === 0)
                            continue;

                        var div = document.createElement('div');
                        div.className = '_bbox bbox_person';
                        div.setAttribute("style", "position: absolute; border: 2px solid #1dec23; width:" + (w * bb['bbox_w']) + "px; height:" + (h * bb['bbox_h']) + "px; top:" + (h * bb['bbox_y'] + 40) + "px; left:" + (w * bb['bbox_x']) + "px");
                        $(div).appendTo($(currentImage).parent());
                    }
                }

            } catch (e) {
                console.log('applyBoundingBoxes e: ', e);
            }
        }
    };

    const preparePDFData = (userCopy) => {
        var pdfData = {};
        let fields = ["user_login", "user_token", "site_id", "customer_id"];
        for (let i = 0; i < fields.length; i++) {
            pdfData[fields[i]] = userCopy[fields[i]];
        };

        if (userCopy.site_selected) {
            pdfData.site_selected = {};
            let fields = ["site_id", "site_name", "site_iana_timezone", "site_city", "site_country", 'site_config'];
            for (let i = 0; i < fields.length; i++) {
                pdfData.site_selected[fields[i]] = userCopy.site_selected[fields[i]];
            }
        }

        if (userCopy.zone_selected) {
            pdfData.zone_selected = {};
            let fields = ["location_id"];
            for (let i = 0; i < fields.length; i++) {
                pdfData.zone_selected[fields[i]] = userCopy.zone_selected[fields[i]];
            }
        }

        if (userCopy.zones) {
            pdfData.zones = [];
            for (let z of userCopy.zones) {
                pdfData.zones.push({ location_name: z.location_name, location_id: z.location_id });
            }
        }

        pdfData.startTime = startTime;
        pdfData.endTime = endTime;
        pdfData.date = date;

        return pdfData;
    }

    const handleChange = e => {
        var currentComment = {
            history_id: e.target.name,
            author: user.user_login,
            datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
            content: e.target.value
        }
        setCurrentComment(currentComment);
    };

    const saveComment = (history_id) => {
        var h_id = currentComment.history_id
        //If comment box ID and Add comment button's ID don't match, terminate
        if (history_id !== Number(h_id)) {
            return
        }

        var zones = [...zonesAfterWorkHrsData]
        var zoneComments = zones.find(z => z.history_id === history_id).comments;
        delete currentComment.history_id
        zoneComments = zoneComments === "" ? [] : zoneComments;
        zoneComments = [...zoneComments, currentComment];

        var data = {
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            operation: 'save-comments',
            comments: JSON.stringify(zoneComments),
            history_id: h_id
        }

        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/human-power',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            (res) => {
                if (res.status && res.status.code === 200)
                    zones.find(z => z.history_id === Number(h_id)).comments = zoneComments
                setZonesAfterWorkHrsData(zones);
                document.getElementById(h_id).value = "";
                Toastr.success('Comment Saved Successfully');
            }
        )
    };

    const includeDateOnPdf = () => {
        var include_weekends = user.site_selected.site_config.work_hours.include_weekends;
        if (moment(date).format('dddd') === "Saturday" && include_weekends !== "6" && include_weekends !== "6 7") {
            return date
        }
        else if (moment(date).format('dddd') === "Sunday" && include_weekends !== "7" && include_weekends !== "6 7") {
            return date
        }
        else {
            return [date, '(',
                (isNightOverlap ?
                    [
                        ['00:00', '-', moment(end_Time, 'hh:mm a').format('HH:mm')].join(' '),
                        [moment(start_Time, 'hh:mm a').format('HH:mm'), '-', '23:59'].join(' ')
                    ].join(', ')
                    :
                    [moment(start_Time, 'hh:mm a').format('HH:mm'), '-', moment(end_Time, 'hh:mm a').format('HH:mm')].join()
                ), ')'
            ].join(' ')
        }
    }

    const onChartBarClick = (i) => {
        var chartElement = i[1] ? i[1] : i[0];
        let vehicleFoundRecord = 0;
        for (let index = 0; index <= chartElement['_index']; index++) {
            const element = sortedZones[index];
            if (element.tracks_count) {
                vehicleFoundRecord++
            }
        }
        let selected_zone = sortedZones[chartElement['_index']];
        if (selected_zone.tracks_count) {
            redirectZoneHistory(selected_zone);
            return
        }
        let cardHeight = $('#card-height').innerHeight();
        $('.modal-body').animate({ scrollTop: ((chartElement['_index'] + 1 - vehicleFoundRecord)) * (cardHeight - 2) }, 500);
    }

    const showAdvancedWorkHrs = () => {
        setShowAdvancedWorkHours(true);
        setTimeout(() => {
            $('.ant-modal-wrap').attr('style', 'z-index: 6000');
        }, 100);
    }

    const resizeModal = (e) => {
        if (e) {
            e.preventDefault();
        }
        $('.modal-dialog').css('width', '');
        $(".modal-dialog").removeClass("ant-modal");
        if ($(window).width() <= 768) {
            $('.ant-modal-content').css({ "top": "62.5px" });
        } else {
            $('.ant-modal-content').css({ "top": "36px" });
        }
        setTimeout(() => {
            $('.fa-chevron-right').trigger('click');
        }, 100);
        setTimeout(() => {
            $('.fa-chevron-left').trigger('click');
        }, 150);
        $(e.target).toggleClass("fa-expand fa-compress");
        $(e.target).closest(".modal-dialog").toggleClass("modal-md modal-fullscreen");
    }

    const redirectZoneHistory = (zone) => {
        let ai_event = { sec_timestamp: zone.dev_timestamp };
        let zone_selected = user.zones.find((z) => z.location_id === zone.location_id);
        var sessionMgr = new SessionManager();
        let User = { ...user }
        User.ai_event = ai_event;
        User.zone_selected = zone_selected;
        sessionMgr.storeCookie("user", User);
        setRedirectHistory(true);
        setLocation_name(zone.location_name);
        setTimeout(() => {
            $(".ant-modal-header").css('padding', '0px');
            $('.ant-modal-wrap').addClass('modal fade show');
            $('.ant-modal-content').css({ "bottom": "36px" });
        }, 100);
    }

    const chartData = () => {
        let zoneIds = [];
        let dataSets = [];
        let allTime = vehicle_info.concat(zonesAfterWorkHrsData);
        let zonesAfterWorkHrsSortedZones = zonesAfterWorkHrsData.sort((a, b) => a.dev_timestamp - b.dev_timestamp)
        sortedZones = allTime.sort((a, b) => a.dev_timestamp - b.dev_timestamp);
        sortedZones.forEach((z, i) => {
            time.push(moment.tz(z.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('h:mm:ss a').toUpperCase());
        });
        zoneIds = [...new Set(zonesAfterWorkHrsData.map(z => z.location_id))];
        zoneIds.forEach(zId => {
            var filteredZone = zonesAfterWorkHrsSortedZones.filter(z => z.location_id === zId);
            var personCount = [], label = "";
            time.forEach((t, i) => {
                if (time[i] === time[i + 1]) {
                    t = 0
                }
                var zoneData = filteredZone.find(zn => moment.tz(zn.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format("h:mm:ss a").toUpperCase() === t);
                if (zoneData) {
                    personCount.push(zoneData.person_count);
                    label = zoneData.location_name + " ";
                }
                else personCount.push(0);
            });
            // var color = this.zones.find(zone => zone.location_id === zId).color;
            var color = 'rgb(9, 109, 217)';
            dataSets.push({ label: label, backgroundColor: color, hoverBackgroundColor: color, data: personCount, skipNull: true });
        });

        var sortedZonesInfo = vehicle_info.sort((a, b) => a.dev_timestamp - b.dev_timestamp);
        zoneIds = [...new Set(vehicle_info.map(z => z.location_id))];
        zoneIds.forEach(zId => {
            var filteredZone = sortedZonesInfo.filter(z => z.location_id === zId);
            var vehicle_count = [], label = "";
            time.forEach((t, i) => {
                if (i !== 0 && time[i - 1] === time[i]) {
                    t = 0
                }
                var zoneData = filteredZone.find(zn => moment.tz(zn.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format("h:mm:ss a").toUpperCase() === t);
                if (zoneData) {
                    vehicle_count.push(1);
                    label = zoneData.location_name + "(Vehicle)";
                }
                else vehicle_count.push(0);
            });
            var color = 'rgb(255, 165, 0)';
            dataSets.push({ key: label, label: label, backgroundColor: color, hoverBackgroundColor: color, data: vehicle_count, skipNull: true });
        });

        if (dataSets.length > 1) {
            dataSets.push({ label: 'All' });
        }
        setSelected_dataset([dataSets[0]]);
        setAll_dataset(dataSets);
        setLoading(false);
    }

    const chart = {
        data: {
            labels: time,
            datasets: selected_dataset
        },
        options: {
            responsive: true,
            onHover: function (event, chartElement) {
                event.target.style.cursor = chartElement.length === 0 ? 'default' : 'pointer';
            },
            onClick: function (e) {
                try {
                    e.stopPropagation();
                    const points = this.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
                    // console.log(points);
                    onChartBarClick(points);
                } catch (e) { }
            },
            legend: {
                display: false,
                align: "start"
            },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var bgColor = data.datasets[tooltipItem.datasetIndex].hoverBackgroundColor;
                        if (bgColor === "rgb(255, 165, 0)") {
                            let details = [];
                            let label = data.datasets[tooltipItem.datasetIndex].label.split("(");
                            details.push(`${label[0]} : Vehicles found`);
                            return details;
                        } else {
                            let details = [];
                            details.push(`${data.datasets[tooltipItem.datasetIndex].label}:${data['datasets'][tooltipItem.datasetIndex]['data'][tooltipItem['index']]}`);
                            return details;
                        }
                    }
                }
            },
            scales: {
                yAxes: [{
                    display: true,
                    gridLines: {
                        display: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: "People / Vehicle Count",
                        fontColor: 'orange'
                    },
                    ticks: {
                        beginAtZero: true,
                        callback: function (value, index, values) {
                            if (Math.round(value) === value) {
                                return value
                            }
                        }
                    }
                }],
                xAxes: [{
                    // stacked: true,
                    display: true,
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        beginAtZero: true
                    },
                    scaleLabel: {
                        display: true,
                        labelString: "Time",
                        fontColor: 'orange'
                    },
                }]
            },
            maintainAspectRatio: false,
        }
    }

    const { TextArea } = Input;
    return (
        <React.Fragment >
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>

            {
                !loading && (
                    <div className="container px-2 py-1 bg-light">
                        <div className="row">
                            <div className="col-md-6 font-weight-bold text-primary pt-1 pl-4">
                                {user && user.site_selected && user.site_selected.site_name}
                            </div>
                            <div className="col-md-6 text-right">
                                <span className="pr-2"><DownloadReport report_url={sdr_url}></DownloadReport></span>
                                {!props.hideDatePicker &&
                                    <DatePicker disabledDate={(current) => current > moment().endOf('day')} showToday={false} allowClear={false} inputReadOnly popupStyle={{ zIndex: 10000 }} onChange={onDateChange} defaultValue={moment(date, 'YYYY-MM-DD')} format={'YYYY-MM-DD'} />
                                }
                            </div>
                        </div>
                    </div>
                )
            }

            {
                !loading &&
                <div className="row" style={{ marginRight: "0", marginLeft: "0" }}>
                    <div className="col-md-7" style={{ marginTop: "8px" }}>
                        <span>&nbsp;
                            {extended_enable && extended_enable === true ? date : includeDateOnPdf()}
                            {extended_enable && extended_enable === true && <i className="fa fa-info-circle ml-2 cursor-pointer" onMouseOver={showAdvancedWorkHrs} data-toggle="tooltip" title="View Advanced Work Hours"></i>}
                        </span>
                    </div>
                </div>
            }

            <div className="modal-body bg-white">
                <div className="p-3">
                    {loading ?
                        <center><Loading> Loading ... </Loading></center> :
                        <div className="card my-2 bg-shadow">
                            <div className="card-body text-center">
                                <div className="row pt-2">
                                    <div className="col-md-12 mt-2 pl-4 text-app text-center" id='select'>
                                        <label className='mr-3'>People: <i className="fa fa-square fa-lg" style={{ color: 'rgb(9, 109, 217)', cursor: "auto" }}></i></label>
                                        <label className='mr-3'>Vehicle: <i className="fa fa-square fa-lg" style={{ color: 'rgb(255, 165, 0)', cursor: "auto" }}></i></label>
                                        <Select
                                            style={{ width: '200px' }}
                                            className='font-size-13 w-175 site_picker text-right shadow-sm bg-white rounded'
                                            dropdownMatchSelectWidth={false}
                                            defaultValue={selected_dataset && selected_dataset[0] && selected_dataset[0].label}
                                            filterOption={(input, option) =>
                                                (option.label).toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={selected_dataset && selected_dataset.length > 1 ? 'All' : selected_dataset && selected_dataset[0] && selected_dataset[0].label}
                                            onChange={(args) => {
                                                let data_selected = all_dataset.find((d) => d.label === args);
                                                if (args === 'All') {
                                                    setSelected_dataset(all_dataset);
                                                } else {
                                                    setSelected_dataset([data_selected]);
                                                }
                                            }}
                                            options={all_dataset && all_dataset.map((a) => { return { value: a.label, label: a.label }; })}
                                            placeholder="Choose Zone"
                                            getPopupContainer={() => document.getElementById('select')}
                                        />
                                    </div>
                                </div>

                                {time.length > 0 ?
                                    <div id="chart_slider" style={{ overflowX: "scroll" }}>
                                        <div style={{ width: time.length > 15 ? `${(time.length * 50) + 'px'}` : '100 %' }}>
                                            <React.Fragment>
                                                <Bar data={chart.data} options={chart.options} height={339} />
                                            </React.Fragment>
                                        </div>
                                    </div>
                                    :
                                    "No Data Found ..."
                                }

                            </div>
                        </div>

                    }

                    {zonesAfterWorkHrsData && zonesAfterWorkHrsData.length > 0 &&
                        <div className="card bg-shadow mb-2">
                            <div className="card-header bg-primary text-light p-2">Events Summary</div>
                            <div className="card-body text-left">
                                <table className="table table-striped">
                                    <tbody>
                                        {zonesAfterWorkHrsData.map(d => {
                                            let c = d.comments;
                                            let t = Array.isArray(c) && c.map((c1, i) =>
                                                <tr className="col-md-3" key={d.author + '_' + d.datetime + '_' + i}>
                                                    <td width="120px" className="text-primary">{moment.tz(d.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('hh:mm:ss a').toUpperCase()}</td>
                                                    <td width="150px" nowrap="true">{location_map[d.location_id]}</td>
                                                    <td>{c1.content}</td>
                                                </tr>
                                            );
                                            return t;
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }

                    <div className="row">
                        {!loading &&
                            sortedZones && sortedZones.map((zone, index) => {
                                return !zone.video_dest_ref &&
                                    <React.Fragment key={zone.location_id + zone.dev_timestamp + index}>
                                        <div className="col-md-12" id='card-height'>
                                            <div className="card bg-shadow mt-4">
                                                <div className="text-app bg-light p-2">
                                                    {zone.location_name.trim() + ", " + moment.tz(zone.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('hh:mm:ss a').toUpperCase()}
                                                </div>
                                                <div className="card-body p-0 cursor-pointer" onClick={() => redirectZoneHistory(zone)}>
                                                    <div className="image_container"><ImageResize resize_perc="0.3" sec_timestamp={zone.dev_timestamp} className="card-img-top img-fluid d-block" id={"bbox_image_" + index} onLoad={() => applyBoundingBoxes('bbox_image_' + index, zone.location_id)} src={zone.image} alt="" /></div>
                                                    {zone.comments !== "" && <List
                                                        className={"p-2"}
                                                        dataSource={zone.comments}
                                                        header={`${zone.comments.length} ${zone.comments.length > 1 ? 'comments' : 'comment'}`}
                                                        itemLayout="horizontal"
                                                        renderItem={items => <li><Comment {...items} /></li>}
                                                    />}
                                                </div>
                                                <div className="card-footer">
                                                    <TextArea id={zone.history_id} name={zone.history_id} rows={2} onChange={handleChange} />
                                                    <button className="btn btn-sm btn-primary pull-right mt-1" type="button" loading={submitting} onClick={() => saveComment(zone.history_id)}>
                                                        Add Comment
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                            })
                        }
                    </div>
                </div>

                {
                    showAdvancedWorkHours &&
                    <div id="adv_worhours_popover" style={{ zIndex: 10000 }}>
                        <Modal
                            title="Advanced Work Hours"
                            bodyStyle={{ padding: '9px 21px' }}
                            footer={[<button key="back" className="btn btn-primary btn-sm" onClick={() => setShowAdvancedWorkHours(false)}>
                                OK
                            </button>]}
                            width={700} closable={false} okButtonProps={{ visibility: 'hidden' }} open={showAdvancedWorkHours} onOk={() => setShowAdvancedWorkHours(false)}>
                            <AdvanceWorkHours view_only={true} />
                        </Modal>
                    </div>
                }

                {redirectHistory &&
                    <div id="adv_worhours_popover" style={{ zIndex: 10000, position: 'relative' }} aria-hidden="true">
                        <Modal
                            maskClosable={false}
                            bodyStyle={{ padding: '9px 21px' }}
                            footer={false}
                            className="modal-dialog modal-md"
                            closable={false}
                            open={redirectHistory}
                            title={
                                [
                                    <div className="modal-header p-2 bg-primary text-white" key={location_name}>
                                        <span className="modal-title">{location_name}</span>
                                        <div>
                                            <button type="button" className="fa fa-expand" onClick={resizeModal}>
                                            </button>
                                            <button type="button" className="far fa-lg fa-times-circle pull-right" data-dismiss="modal" onClick={() => setRedirectHistory(false)}>
                                            </button>
                                        </div>
                                    </div>
                                ]}
                            onCancel={() => setRedirectHistory(false)}>
                            <ZoneHistoryCarousel hideNotification={true} />
                        </Modal>
                    </div>
                }

            </div>
            <div className="modal-footer bg-light" style={{ padding: '0.5rem 1rem' }}>
                {/* {!this.state.loading && <a target='_blank' rel='noopener noreferrer' onClick={() => { this.handleClick() }} href={this.state.sdr_url} className="btn btn-white btn-sm"><i className="far fa-file-pdf text-danger"></i> Download PDF</a>} */}
            </div>
        </React.Fragment >
    );
}

export default AfterHoursVisitorsReport;